<template>
  <div class="content content5">
      <p class="nav clearfix">
          <span class="fl title">#<span>最新资讯</span></span>
          <router-link :to="{name: 'NewsMore', params: {renderContent: 1}}" class="fr more">更多新闻 ></router-link>
      </p>
    <ul>
        <li v-for="item in newsList" :key="item.id" @click="gotoNewsDeatil">
            <img :src="item.imgUrl" alt="" width="100%">
            <div class="info">
                <p class="date">{{item.date}}</p>
                <span class="tit">{{item.title}}</span>
            </div>
        </li>
    </ul>
  </div>
</template>

<script>
import newsPic1 from './pic_news1.jpg'
import newsPic2 from './pic_news2.jpg'
import newsPic3 from './pic_news3.jpg'

export default {
  data () {
    return {
      newsList: [
        {
          id: 0,
          title: '亚商对话丨张琼女士受邀成为新加坡证券交易所SGX首位中国大陆对话者',
          date: '2021年06月23日',
          imgUrl: require('./21-0623-cover.jpg')
        },
        {
          id: 1,
          title: '亚商荣誉丨亚商资本获融中2020最佳创投机构TOP50，张琼女士获最佳投资人TOP50',
          date: '2021年01月15日',
          imgUrl: require('./21-0115-cover.jpg')
        },
        {
          id: 2,
          title: '亚商观点丨创新消费投资处在跑马圈地时期，内功浑厚才能实现长期主义',
          date: '2020年10月16日',
          imgUrl: require('./20-1016-cover.jpg')
        }
      ]
    }
  },
  methods: {
    gotoNewsDeatil () {
      this.$router.push({path: '/newsMore'})
    }
  }
}
</script>

<style scoped>
.content5{
    min-width: 1200px;
    padding-top: 200px;
}
.content5 .nav{
  padding: 0 120px 0px 174px;
  margin-bottom: 90px;
}
.content5 .nav .title{
  font-size: 24px;
  color: #c70016;
  font-weight: 600;
}
.content5 .nav .title span{
    font-weight: 600;
    color: #333367;
}
.content5 .nav .more{
    color: #1e1e1e;
    font-size: 18px;
}
.content5 ul{
    width: 100%;
}
.content5 ul li{
    display: inline-block;
    width: 31%;
    margin-right: 3.5%;
    position: relative;
    overflow: hidden;
}
.content5 ul li:last-child{
    margin-right: 0;
}
.content5 li div,.content5 li .info span{
    display: inline-block;
}
.content5 li .info{
    width: 100%;
    height: 150px;
    position: absolute;
    left: 0;
    bottom: -150px;;
    background: rgba(51, 51, 102, 0.9);
    -moz-background: rgba(51, 51, 102, 0.9);
    color: #fff;
    text-align: left;
    padding: 0 30px;
    box-sizing: border-box;
    transition: all 0.6s;
    -moz-transition: all 0.6s;
}
.content5 li .info span{
    display: inline-block;
}
.content5 li .date{
    font-size: 18px;
    margin: 26px 0;
}
.content5 li .tit{
    font-size: 20px;
    line-height: 28px;
}
.content5 li:hover .info{
    bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/news/news.vue